import React from 'react';
import { Tooltip, Icon, Spin } from 'antd';
import AddActivity from './addActivity';
import DisabledPopup from './disabledPopup.js';
import ActivityGallery from './ActivityGallery';
import nolog_blue from '../../../images/nolog_blue.png';
import nolog_pink from '../../../images/nolog_pink.png';
import nolog_gray from '../../../images/nolog_gray.png';

class Action extends React.Component {
  state = {
    addingActivity: false,
    editing: false,
    editingId: null,
    galleryOpen: false,
    slide: 0,
    disabledPopup: false,
    loading: false
  };

  componentDidUpdate = prevProps => {
    const { editingId, editing } = this.state;
    if (
      editing &&
      prevProps.data.actionObject !== this.props.data.actionObject
    ) {
      this.setState({ editing: this.props.data.actionObject[editingId] });
    }
  };

  addActivity = async activity => {
    this.setState({
      addingActivity: false,
      editing: false,
      editingId: null,
      loading: true
    });
    if (this.state.editing) {
      await this.props.addActivity(activity, this.state.editingId);
    } else {
      await this.props.addActivity(activity);
    }
    this.setState({ loading: false });
  };

  editActivity = id => {
    let editing = this.props.data.actionObject[id];
    this.setState({
      editing,
      editingId: id,
      addingActivity: true,
      galleryOpen: false
    });
  };

  openGallery = index => {
    this.setState({ galleryOpen: true, slide: index });
  };

  isDisabled = () => {
    const { data } = this.props;
    const activityList =
      data && data.actionObject ? Object.entries(data.actionObject) : [];
    if (activityList.length > 0 && this.props.currentPhase >= 3) {
      return false;
    } else {
      return true;
    }
  };

  saveData = () => {
    const data = {
      current_phase: 'Reflection',
      Action: {
        is_complete: true,
        ...this.props.data
      }
    };
    this.props.saveData(data);
  };

  render() {
    const { color, t, disabled, icon, data, projectCompleted } = this.props;
    const { loading } = this.state;
    const activityList =
      data && data.actionObject ? Object.entries(data.actionObject) : [];
    const loadingIcon = (
      <Icon
        type="loading"
        style={{ fontSize: 36, marginTop: 10, color }}
        spin
      />
    );

    const styles = {
      addBtn: {
        fontSize: 50,
        fontFamily: 'Times new roman',
        color: 'white',
        backgroundColor: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 60,
        width: 60,
        borderRadius: '50%',
        cursor: 'pointer',
        position: 'fixed',
        right: 25,
        bottom: 55,
        zIndex: 99
      },
      gallery: {
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        paddingTop: 130,
        zIndex: 99
      },
      closeicon: {
        position: 'absolute',
        right: 20,
        top: 20,
        color: 'white',
        fontSize: 50,
        opacity: 0.8,
        cursor: 'pointer',
        zIndex: 2
      },
      nextBtn: {
        fontSize: 16,
        backgroundColor: this.props.color,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'pointer'
      },
      disabledNextBtn: {
        fontSize: 16,
        backgroundColor: '#d0d0d0',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'not-allowed'
      },
      text: {
        fontSize: 18,
        textAlign: 'center',
        marginTop: 20,
        color: color,
        fontFamily: 'Arial Rounded MT Bold'
      },
      button: {
        margin: '0 auto',
        backgroundColor: disabled ? '#d0d0d0' : this.props.color,
        color: 'white',
        border: 'none',
        cursor: !disabled && 'pointer',
        borderRadius: '20px',
        width: 150,
        textAlign: 'center',
        marginTop: 20,
        padding: 5,
        marginBottom: 20
      }
    };

    let noLogImg;
    if (color == '#F190AC') {
      noLogImg = nolog_pink;
    } else if (color == '#7c868d') {
      noLogImg = nolog_gray;
    } else {
      noLogImg = nolog_blue;
    }

    return (
      <div style={{ position: 'absolute', width: '100%', top: 260 }}>
        {this.state.galleryOpen && (
          <div style={{ position: 'absolute', top: -260 }}>
            <div className="overlay" />
            <div style={styles.gallery}>
              <Icon
                onClick={() => this.setState({ galleryOpen: false })}
                style={styles.closeicon}
                type="close"
              />
              <ActivityGallery
                projectCompleted={projectCompleted}
                editActivity={this.editActivity}
                color={color}
                data={activityList}
                slide={this.state.slide}
                t={t}
              />
            </div>
          </div>
        )}
        <div style={{ maxWidth: 650, margin: '0 auto', paddingBottom: 70 }}>
          {activityList && activityList.length > 0 ? (
            <div>
              {activityList.map((act, i) => (
                <Activity
                  data={act}
                  color={color}
                  t={t}
                  openGallery={this.openGallery}
                  index={i}
                />
              ))}
              {loading && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Spin indicator={loadingIcon} />
                </div>
              )}
              <div
                onClick={() =>
                  !disabled && this.setState({ addingActivity: true })
                }
                style={styles.button}>
                Add new activity
              </div>
            </div>
          ) : (
            <div>
              <img
                src={noLogImg}
                style={{ display: 'block', margin: '0 auto', marginTop: 50 }}
              />
              <h3 style={styles.text}>Ready to add activities?</h3>
              {loading && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Spin indicator={loadingIcon} />
                </div>
              )}
              <div
                onClick={() =>
                  !disabled && this.setState({ addingActivity: true })
                }
                style={styles.button}>
                Add new activity
              </div>
            </div>
          )}
        </div>
        <AddActivity
          t={t}
          icon={icon}
          editing={this.state.editing}
          open={this.state.addingActivity}
          color={color}
          addActivity={this.addActivity}
          deleteFile={(url, index) =>
            this.props.deleteFile(url, index, this.state.editingId)
          }
          close={() =>
            this.setState({
              addingActivity: false,
              editing: false,
              editingId: false
            })
          }
        />
        <div
          onClick={() =>
            !this.isDisabled() && !projectCompleted
              ? this.saveData()
              : !projectCompleted && this.setState({ disabledPopup: true })
          }
          style={
            this.isDisabled() || projectCompleted
              ? styles.disabledNextBtn
              : styles.nextBtn
          }>
          {t('Next Phase')}
        </div>
        {!projectCompleted && (
          <DisabledPopup
            open={this.state.disabledPopup}
            close={() => this.setState({ disabledPopup: false })}
            color={color}
          />
        )}
      </div>
    );
  }
}

export default Action;

const Activity = ({ data, color, t, openGallery, index }) => (
  <div
    style={{
      borderRadius: 10,
      boxShadow: '0 0 2px 0 rgba(0,0,0,0.3)',
      backgroundColor: 'white',
      padding: 20,
      cursor: 'pointer',
      marginBottom: 20
    }}
    onClick={() => openGallery(index)}>
    <h3
      style={{
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color
      }}>
      {t('Title Activity')}
    </h3>
    <p
      style={{
        marginBottom: 0,
        fontSize: 14,
        fontFamily: 'Helvetica Neue',
        color: color,
        marginBottom: 20
      }}>
      {data[1].title}
    </p>
    <h3
      style={{
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color
      }}>
      {t('Notes')}
    </h3>
    <p
      style={{
        marginBottom: 0,
        fontSize: 14,
        fontFamily: 'Helvetica Neue',
        color: color,
        marginBottom: 20
      }}>
      {data[1].notes}
    </p>
    <div style={{ display: 'inline-flex' }}>
      <Icon
        style={{ color: color, fontSize: 12, marginRight: 5 }}
        type="paper-clip"
      />
      <p
        style={{
          marginBottom: 0,
          fontSize: 12,
          fontFamily: 'Arial Rounded MT Bold',
          color: color
        }}>
        {data[1].downloadURL ? data[1].downloadURL.length : 0}{' '}
        {t('Attachments')}
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/action.js